import React from 'react';

const Button = ({ children, onClick, className = '', ...props }) => {
 return (
 <button
 onClick={onClick}
 className={`px-4 py-2 bg-secondary hover:bg-primary text-white rounded-2xl font-semibold transition duration-200 ${className}`}
 {...props}
 >
 {children}
 </button>
 );
};

export default Button;



